import { addBaseUrlToUrls, commonEnvironment } from "./environment.common";

export const environment = {
	...commonEnvironment,
	production: false,
	baseUrl: 'https://staging-api.kastenman.be',
	odooUrl: '',
	// Point local dev at the live Odoo lead endpoint so the offerte form can be tested
	// from localhost. NB: submissions create REAL leads in the CRM. Set back to '' to
	// disable. (Production builds use environment.prod.ts, unaffected by this.)
	crmLeadUrl: 'https://kastenman.odoocloud.nl/configurator/website_lead',
	// Staging has no Odoo URL: mock the sale-order lines so the quotation flow is testable.
	quotationMockOrderLines: true,
	// Round elements stay dormant here: the backend does not take them yet.
	roundElements: false,
	cognito: {
		REGION: 'eu-central-1',
		USER_POOL_ID: 'eu-central-1_U3hKpF0LJ',
		APP_CLIENT_ID: '587pjcnqlc63r8c41jopkduoq5',
		IDENTITY_POOL_ID: 'eu-central-1:be92e5d0-9bc0-42fb-80f7-9a76bbfa771a',
	},
	wsUrl: 'wss://staging-ws.kastenman.be'
};

addBaseUrlToUrls(environment, commonEnvironment);
